import getters from './getters';
import mutations from './mutations';
import actions from './actions';
const state = {
    sessionTimeoutUnix: 0,
    state: '',
    fbUser: null,
    fbToken: null,
    account: null,
    token: null,
    profile: null,
    profiles: [],
    profileByID: new Map()
};
const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
export default module;
